import { Navigate, useSearchParams } from 'react-router-dom';

import { optionsService } from '@/services/instance/optionsService';
import { getLoginUrl } from '@/utils/getPageUrl';

export const NavigateToDefaultRoute = () => {
    const [searchParams] = useSearchParams();

    const email = searchParams.get('email');

    const loginUrl = getLoginUrl({
        ...optionsService.getQueryArgs(),
        email,
    });

    return <Navigate to={loginUrl} />;
};
